// Lightweight typed helpers for talking to the Ohana backend.
const BASE = process.env.REACT_APP_BACKEND_URL;

if (!BASE) {
  console.warn('REACT_APP_BACKEND_URL is not set. API calls will fail.');
}

export const API_URL = `${BASE}/api`;

export async function fetchJson(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { Accept: 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    const err = new Error(`Request failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function listBlogPosts({ limit = 50, offset = 0 } = {}) {
  return fetchJson(`/posts?limit=${limit}&offset=${offset}`);
}

export async function getBlogPostBySlug(slug) {
  return fetchJson(`/posts/${encodeURIComponent(slug)}`);
}
